import * as React from 'react';
import { Heading, Card, ToggleSwitch, Text, Box, TextButton } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { AppContext } from '@src/context/store';
import { DisableApproval } from '../../prompts/disable-approval';
import { isAppEnabled, getKBLinks } from '@src/context/selectors/ui-settings';

import * as css from '../../banner-settings.scss';

const ToggleCardComponent = ({ t }: InjectedTranslateProps) => {
  const store = React.useContext(AppContext);
  const appEnabled = isAppEnabled(store);
  const kbs = getKBLinks(store);

  const [disableApprovalVisible, setDisableApprovalVisible] = React.useState(false);
  const showDisableApproval = () => setDisableApprovalVisible(true);
  const hideDisableApproval = () => setDisableApprovalVisible(false);

  const toggleAppEnabled = async () => {
    const newAppEnabled = !appEnabled;
    await store.setPendingAppEnabled(newAppEnabled);
    if (!newAppEnabled && store.isAppInstalled) {
      await store.disableAppAndSaveChanges();
    }
    hideDisableApproval();
  };

  const onAppEnabledToggle = () => {
    if (appEnabled) {
      showDisableApproval();
    } else {
      toggleAppEnabled();
    }
  };

  const onLearnMoreClicked = () => window.open(kbs.DisplayCookieBannerOnSite, '_blank');

  return (
    <Card dataHook={DataHooks.ToggleCookieBannerContainer} className={css.section}>
      <Box padding={'26px'} verticalAlign={'middle'} marginBottom={'36px'}>
        <ToggleSwitch onChange={onAppEnabledToggle} checked={appEnabled} dataHook={DataHooks.ToggleCookieBanner} />
        <Box direction={'vertical'} marginLeft={'24px'}>
          <Heading appearance={'H4'} dataHook={DataHooks.ToggleCookieBannerTitle}>
            {t('display.banner.on.site.title')}
          </Heading>
          <Text dataHook={DataHooks.ToggleCookieBannerSubtitle} size={'small'} weight={'thin'}>
            {t('display.banner.on.site.subtitle')}
            <TextButton className={css.learnMoreButton} size={'small'} onClick={onLearnMoreClicked}>
              {t('learn.more')}
            </TextButton>
          </Text>
        </Box>
      </Box>
      <DisableApproval isOpen={disableApprovalVisible} onOk={toggleAppEnabled} onCancel={hideDisableApproval} />
    </Card>
  );
};

export const ToggleCard = translate()(ToggleCardComponent);
